import { createFileRoute } from '@tanstack/react-router';
import { Boxes, Loader2 } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { IntegrationsGrid } from '@/components/company/integrations';
import { useCompany } from '@/hooks/use-company';

export const Route = createFileRoute('/(app)/integrations/')({
  component: IntegrationsPage,
});

function IntegrationsPage() {
  const { selectedCompany, isLoading } = useCompany();

  return (
    <div className="container max-w-6xl py-8 space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Boxes className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-lg">Integrations</CardTitle>
              <CardDescription>
                Connect third-party services like HRMS, banking, and communication tools.
              </CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>

      {isLoading ? (
        <Card>
          <CardContent className="flex items-center justify-center py-12">
            <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          </CardContent>
        </Card>
      ) : !selectedCompany ? (
        <Card>
          <CardContent className="py-12 text-center text-sm text-muted-foreground">
            Select a company to configure integrations.
          </CardContent>
        </Card>
      ) : (
        <IntegrationsGrid companyId={selectedCompany.id} />
      )}
    </div>
  );
}
